import React from 'react'
import Header from './common/Header'

function Faq() {

  // const FaQs = [
  //   {
  //     Que: "Which wallets can I use?",
  //     Ans: "For smartphone / tablet devices you can either use Trust Wallet or Coinbase Wallet. Otherwise, if you are on a desktop / laptop, then you can use MetaMask."
  //   },
  //   {
  //     Que: "Do I need to send tokens or ETH to the Crypto MultiTokendrop smart contract?",
  //     Ans: "No, you should never send your tokens or ETH to the Crypto MultiTokendrop smart contract. The only requirement is that your tokens or ETH is stored in the wallet you are using to interact with Crypto MultiTokendrop."
  //   },
  //   {
  //     Que: "How many addresses can I distribute tokens and ETH to in a single transaction?",
  //     Ans: "Crypto MultiTokendrop can distribute tokens and ETH to at least 200 addresses at a time. However, the application can be pushed to its limits but this must be done with caution so as to not exceed the imposed gas limit. A good rule of thumb is to not sign a transaction if an error displayed on your wallet, in which case you should lower the amount of addresses and try again."
  //   },
  //   {
  //     Que: "How long does it take for a batch transfer to be processed?",
  //     Ans: "The duration it takes for your batch transfer to be processed depends entirely on network congestion and also the gas price you pay. The more congested the network is, the higher gas prices will be. You must ensure to set a sufficient gas price in order for your transaction to be processed in a timely manner. Otherwise, if you set a gas price which is too low, your transaction could take hours and in some extreme cases days to be processed."
  //   },
  // ]
  return (
    <>
      <Header />
      <section className="section2" id="" data-section="section1">
        <div className="container">
          <div className="caption">
            <div className="btm-form" style={{ padding: "50px 15px 50px" }}>
              <div className="pb-5">
                <div className="col-md-11 m-auto">
                  <h1 className="mb-5 text-center"><b>Frequently Asked Questions</b></h1>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-11 mx-auto">

                        <div id="accordionExample" className="accordion shadow">
                          <div className="card">
                            <div id="headingOne" className="card-header  shadow-sm border-0">
                              <h2 className="mb-0 w-100 p-0">
                                <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                  aria-controls="collapseOne"
                                  className="btn btn-link text-dark font-weight-bold text-uppercase collapsible-link">Which wallets can I use?</button>
                              </h2>
                            </div>
                            <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample" className="collapse show">
                              <div className="card-body p-5">
                                <p className=" m-0" style={{ color: "#000" }}>For smartphone / tablet devices you can either use Trust Wallet or Coinbase Wallet. Otherwise, if you are on a desktop / laptop, then you can use MetaMask.</p>
                              </div>
                            </div>
                          </div>

                          <div className="card">
                            <div id="headingTwo" className="card-header  shadow-sm border-0">
                              <h2 className="mb-0 w-100 p-0">
                                <button type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                                  aria-controls="collapseTwo"
                                  className="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">Do I need to send tokens or ETH to the Crypto MultiTokendrop smart contract?</button>
                              </h2>
                            </div>
                            <div id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordionExample" className="collapse">
                              <div className="card-body p-5">
                                <p className=" m-0" style={{ color: "#000" }}>No, you should never send your tokens or ETH to the Crypto MultiTokendrop smart contract. The only requirement is that your tokens or ETH is stored in the wallet you are using to interact with Crypto MultiTokendrop.</p>
                              </div>
                            </div>
                          </div>

                          <div className="card">
                            <div id="headingThree" className="card-header  shadow-sm border-0">
                              <h2 className="mb-0 w-100 p-0">
                                <button type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                                  aria-controls="collapseThree"
                                  className="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">How many addresses can I distribute tokens and ETH to in a single transaction?</button>
                              </h2>
                            </div>
                            <div id="collapseThree" aria-labelledby="headingThree" data-parent="#accordionExample" className="collapse">
                              <div className="card-body p-5">
                                <p className=" m-0" style={{ color: "#000" }}>Crypto MultiTokendrop can distribute tokens and ETH to at least 500 addresses at a time. However, the application can be pushed to its limits but this must be done with caution so as to not exceed the imposed gas limit. A good rule of thumb is to not sign a transaction if an error displayed on your wallet, in which case you should lower the amount of addresses and try again.</p>
                              </div>
                            </div>
                          </div>

                          <div className="card">
                            <div id="headingfour" className="card-header  shadow-sm border-0">
                              <h2 className="mb-0 w-100 p-0">
                                <button type="button" data-toggle="collapse" data-target="#collapsefour" aria-expanded="false"
                                  aria-controls="collapsefour"
                                  className="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">How long does it take for a batch transfer to be processed?</button>
                              </h2>
                            </div>
                            <div id="collapsefour" aria-labelledby="headingfour" data-parent="#accordionExample" className="collapse">
                              <div className="card-body p-5">
                                <p className=" m-0" style={{ color: "#000" }}>The duration it takes for your batch transfer to be processed depends entirely on network congestion and also the gas price you pay. The more congested the network is, the higher gas prices will be. You must ensure to set a sufficient gas price in order for your transaction to be processed in a timely manner. Otherwise, if you set a gas price which is too low, your transaction could take hours and in some extreme cases days to be processed.</p>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Faq